import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime'
import { forwardRef } from 'react'
const SvgBrandIconVoucher = (props, ref) =>
  _jsxs('svg', {
    viewBox: '0 0 48 48',
    xmlns: 'http://www.w3.org/2000/svg',
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    ref: ref,
    ...props,
    children: [
      _jsx('circle', { cx: 24, cy: 24, r: 24, fill: '#fcf7f7' }),
      _jsx('path', {
        d: 'M27.7 26.467a.477.477 0 1 1-.956 0 .477.477 0 0 1 .955 0m4.168-2.592a7.868 7.868 0 1 1-15.736 0 7.868 7.868 0 0 1 15.736 0m-10.836-.996c.814 0 1.477-.662 1.477-1.477s-.663-1.477-1.477-1.477-1.478.662-1.478 1.477.663 1.477 1.478 1.477m5.632-1.934a.501.501 0 0 0-.838-.546l-4.236 6.499a.5.5 0 0 0 .838.547zm2.035 5.522a1.478 1.478 0 0 0-2.954 0 1.478 1.478 0 0 0 2.954 0m-7.667-5.542a.478.478 0 1 0 0 .955.478.478 0 0 0 0-.955M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24m-10.414-.918 1.673-2.596c.36-.56.36-1.277 0-1.836l-1.673-2.595a1.69 1.69 0 0 1 0-1.836l1.816-2.818a.452.452 0 0 0-.38-.697H11.628v8.855a.5.5 0 1 1-1 0v-8.854H5.25A22.87 22.87 0 0 0 1 24c0 4.952 1.578 9.539 4.25 13.296h5.378v-8.854a.5.5 0 1 1 1 0v8.854h27.394a.452.452 0 0 0 .38-.697l-1.816-2.818a1.69 1.69 0 0 1 0-1.836l1.673-2.595c.36-.56.36-1.277 0-1.836l-1.673-2.596a1.69 1.69 0 0 1 0-1.836',
      }),
    ],
  })
const ForwardRef = forwardRef(SvgBrandIconVoucher)
export default ForwardRef
